console.log('=== Variant Image Filter Script Loaded ===');

class VariantImageFilter {
  constructor() {
    console.log('VariantImageFilter initialized');
    this.init();
  }

  init() {
    const dropdowns = document.querySelectorAll('.luxury-select-box');
    console.log('Found dropdowns:', dropdowns.length);

    dropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', (e) => {
        console.log('Dropdown changed to:', e.target.value);
        this.handleColorChange(e.target.value);
      });
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('select[name*="Color"], select[name*="color"]')) {
        this.handleColorChange(e.target.value);
      }
    });

    setTimeout(() => this.filterOnLoad(), 1500);
  }

  handleColorChange(colorValue) {
    if (!colorValue) return;
    const normalizedColor = colorValue.toLowerCase().trim();
    console.log('Handling color change:', normalizedColor);

    this.filterDesktop(normalizedColor);
    this.filterMobile(normalizedColor);
  }

  // ─── DESKTOP ───────────────────────────────────────────────
  filterDesktop(normalizedColor) {
    const galleryImages = document.querySelectorAll(
      '.product__media-desktop .gallery-img.image, ' +
      '.product_media-desktop .gallery-img.image'
    );

    let firstMatchIndex = -1;
    let matchCount = 0;

    galleryImages.forEach((el, index) => {
      const img = el.querySelector('img');
      if (!img) return;
      const alt = (img.getAttribute('alt') || '').toLowerCase().trim();
      const matches = alt.includes(normalizedColor);

      if (matches) {
        if (firstMatchIndex === -1) firstMatchIndex = index;
        matchCount++;
        el.style.removeProperty('display');
        el.classList.remove('d-none', 'hidden');
      } else {
        el.style.display = 'none';
        el.classList.add('d-none');
      }
    });

    // Show all if no match
    if (matchCount === 0) {
      galleryImages.forEach(el => {
        el.style.removeProperty('display');
        el.classList.remove('d-none', 'hidden');
      });
    }

    // Update desktop swiper
    setTimeout(() => {
      const desktopSwiper = document.querySelector(
        '.product__media-desktop .swiper, .product_media-desktop .swiper'
      );
      if (desktopSwiper && desktopSwiper.swiper) {
        desktopSwiper.swiper.update();
        if (firstMatchIndex >= 0) desktopSwiper.swiper.slideTo(firstMatchIndex, 0);
      }
    }, 100);
  }

  // ─── MOBILE MAIN GALLERY ───────────────────────────────────
  filterMobile(normalizedColor) {
    // Main gallery swiper - use data-alt on the slide itself
    const mainSwiperEl = document.querySelector('.bls__swiper-gallery-mobile');
    if (!mainSwiperEl) {
      console.log('Mobile main swiper not found');
      return;
    }

    const mainSlides = mainSwiperEl.querySelectorAll('.swiper-slide');
    let firstMatchIndex = -1;
    let matchCount = 0;

    mainSlides.forEach((slide, index) => {
      // Use data-alt on the slide element directly (confirmed in your HTML)
      const slideAlt = (slide.getAttribute('data-alt') || '').toLowerCase().trim();
      // Also check inner img as fallback
      const img = slide.querySelector('img');
      const imgAlt = (img ? (img.getAttribute('alt') || '') : '').toLowerCase().trim();

      const matches = slideAlt.includes(normalizedColor) || imgAlt.includes(normalizedColor);

      if (matches && firstMatchIndex === -1) {
        firstMatchIndex = index;
        matchCount++;
      }
    });

    console.log(`Mobile: found first match at index ${firstMatchIndex} for "${normalizedColor}"`);

    // Also show/hide the inner .gallery-img div so image is visible
    mainSlides.forEach((slide, index) => {
      const slideAlt = (slide.getAttribute('data-alt') || '').toLowerCase().trim();
      const img = slide.querySelector('img');
      const imgAlt = (img ? (img.getAttribute('alt') || '') : '').toLowerCase().trim();
      const matches = slideAlt.includes(normalizedColor) || imgAlt.includes(normalizedColor);

      const galleryImg = slide.querySelector('.gallery-img');
      if (galleryImg) {
        if (matches || matchCount === 0) {
          galleryImg.style.removeProperty('display');
          galleryImg.classList.remove('d-none', 'hidden');
        } else {
          galleryImg.style.display = 'none';
          galleryImg.classList.add('d-none');
        }
      }
    });

    // Slide to first match WITHOUT hiding slides (key fix)
    setTimeout(() => {
      if (mainSwiperEl.swiper) {
        const targetIndex = firstMatchIndex >= 0 ? firstMatchIndex : 0;
        console.log('Sliding mobile main to index:', targetIndex);
        mainSwiperEl.swiper.slideTo(targetIndex, 300);
        mainSwiperEl.swiper.update();
      }

      // ─── THUMBNAIL SWIPER ─────────────────────────────────
      this.filterMobileThumbnails(normalizedColor, firstMatchIndex);
    }, 150);
  }

  // ─── MOBILE THUMBNAILS ─────────────────────────────────────
  filterMobileThumbnails(normalizedColor, mainFirstIndex) {
    const thumbSwiperEl = document.querySelector('.bls__swiper-gallery-thumbnails-mobile');
    if (!thumbSwiperEl) {
      console.log('Thumbnail swiper not found');
      return;
    }

    const thumbSlides = thumbSwiperEl.querySelectorAll('.swiper-slide');
    let firstThumbMatchIndex = -1;

    thumbSlides.forEach((slide, index) => {
      // Thumbnails use data-alt on slide element
      const slideAlt = (slide.getAttribute('data-alt') || '').toLowerCase().trim();
      const img = slide.querySelector('img');
      const imgAlt = (img ? (img.getAttribute('alt') || '') : '').toLowerCase().trim();
      const matches = slideAlt.includes(normalizedColor) || imgAlt.includes(normalizedColor);

      if (matches && firstThumbMatchIndex === -1) {
        firstThumbMatchIndex = index;
      }

      // Show/hide thumbnail slides visually
      if (matches) {
        slide.style.removeProperty('display');
        slide.classList.remove('d-none', 'hidden');
      } else {
        slide.style.display = 'none';
        slide.classList.add('d-none');
      }
    });

    // Update thumbnail swiper
    if (thumbSwiperEl.swiper) {
      thumbSwiperEl.swiper.update();
      if (firstThumbMatchIndex >= 0) {
        thumbSwiperEl.swiper.slideTo(firstThumbMatchIndex, 0);
      }
      console.log('Thumbnail swiper updated, sliding to:', firstThumbMatchIndex);
    }
  }

  filterOnLoad() {
    console.log('=== Filter on load ===');
    const dropdown = document.querySelector('.luxury-select-box');
    if (dropdown && dropdown.value) {
      this.handleColorChange(dropdown.value);
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VariantImageFilter());
} else {
  new VariantImageFilter();
}